export type OffersSlimVariant = 'default' | 'autohide';

export const isAutohide = ({ variant }: Record<string | 'variant', any>) => variant === 'autohide';
